import React from 'react';
import { Input, Label } from 'reactstrap';
import DropdownList from 'react-widgets/DropdownList';
import 'react-widgets/styles.css';

const displayValue = (value) => {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    return String(value);
};

const controlClassName = (compact) =>
    `afas-form-field__control form-control${compact ? ' form-control-sm clooser-control clooser-control--compact' : ''}`;

const selectClassName = (compact) =>
    `afas-form-field__control form-select${compact ? ' form-select-sm clooser-control clooser-control--compact' : ''}`;

const AfasFormField = ({ field, value = '', onChange, compact = false }) => {
    const inputId = `afas-field-${field.id}`;
    const isReadOnly = Boolean(field.readOnly);
    const isDisplayOnly =
        isReadOnly && field.type !== 'radio' && field.type !== 'checkbox' && field.type !== 'select';

    if (isDisplayOnly) {
        return (
            <div
                className={`afas-form-field afas-form-field--stacked afas-form-field--display${
                    field.col === 'inline' ? ' afas-form-field--inline' : ''
                }${field.type === 'textarea' ? ' afas-form-field--display-multiline' : ''}`}
            >
                <span className="afas-form-field__label">{field.label}</span>
                <span className="afas-form-field__value">{displayValue(value)}</span>
            </div>
        );
    }

    if (field.type === 'radio') {
        return (
            <div className="afas-form-field afas-form-field--stacked afas-form-field--radio">
                <Label className="afas-form-field__label">{field.label}</Label>
                <div className="afas-form-field__radio-group">
                    {field.options.map((option) => (
                        <Label key={option.value} className="afas-form-field__radio" check>
                             {option.label}
                            <Input
                                type="radio"
                                name={field.id}
                                value={option.value}
                                checked={option.value === (value || 'no')}
                                disabled={isReadOnly}
                                onChange={() => onChange?.(option.value)}
                            />
                           
                        </Label>
                    ))}
                </div>
            </div>
        );
    }

    if (field.type === 'checkbox') {
        return (
            <div className="afas-form-field afas-form-field--checkbox">
                <Label className="afas-form-field__checkbox" check>
                    <Input type="checkbox" id={inputId} disabled={isReadOnly} />
                    {field.label}
                </Label>
            </div>
        );
    }

    if (field.type === 'textarea') {
        return (
            <div className="afas-form-field afas-form-field--stacked">
                <Label htmlFor={inputId} className="afas-form-field__label">{field.label}</Label>
                <Input
                    id={inputId}
                    type="textarea"
                    rows={field.rows || 3}
                    readOnly={isReadOnly}
                    value={value ?? ''}
                    className={controlClassName(compact)}
                />
            </div>
        );
    }

    // if (field.type === 'select') {
    //     return (
    //         <div className="afas-form-field afas-form-field--stacked">
    //             <Label htmlFor={inputId} className="afas-form-field__label">{field.label}</Label>
    //             {/* <Input
    //                 id={inputId}
    //                 type="select"
    //                 className={selectClassName(compact)}
    //                 value={value || ''}
    //                 disabled={isReadOnly}
    //                 onChange={(event) => onChange?.(event.target.value)}
    //             >
    //                 {field.placeholder && (
    //                     <option value="">{field.placeholder}</option>
    //                 )}
    //                 {!field.placeholder && field.allowEmpty && (
    //                     <option value="" />
    //                 )}
    //                 {(field.options || []).map((option) => (
    //                     <option
    //                         key={`${option.selector ?? ''}::${option.value}::${option.label}`}
    //                         value={option.value}
    //                     >
    //                         {option.label}
    //                     </option>
    //                 ))}
    //             </Input> */}
    //                <DropdownList
    //             id={inputId}
    //             data={options}
    //             dataKey="value"
    //             textField="label"
    //             value={selectedOption}
    //             onChange={(option) => onChange?.(option?.value ?? '')}
    //             disabled={isReadOnly}
    //             placeholder={field.placeholder || ''}
    //             className={selectClassName(compact)}
    //         />
    //         </div>
    //     );
    // }
    
if (field.type === 'select') {
    const options = field.options || [];

    const selectedOption = options.find(
        (option) => String(option.value) === String(value ?? '')
    ) || null;

    const dropdownData = [
        ...(field.placeholder
            ? [{ value: '', label: field.placeholder }]
            : field.allowEmpty
                ? [{ value: '', label: '' }]
                : []),
        ...options,
    ];

    return (
        <div className="afas-form-field afas-form-field--stacked">
            <Label
                htmlFor={inputId}
                className="afas-form-field__label"
            >
                {field.label}
            </Label>

            <DropdownList
                id={inputId}
                data={dropdownData}
                dataKey="value"
                textField="label"
                value={selectedOption}
                onChange={(option) => onChange?.(option?.value ?? '')}
                disabled={isReadOnly}
                placeholder={field.placeholder || ''}
                className={selectClassName(compact)}
            />
        </div>
    );
}


    if (field.type === 'number-stepper') {
        const min = Number.isFinite(field.min) ? field.min : undefined;
        const max = Number.isFinite(field.max) ? field.max : undefined;
        const current = value === '' || value === null || value === undefined
            ? null
            : Number(value);

        const stepBy = (delta) => {
            let next = Number.isFinite(current) ? current + delta : (min ?? 0);
            if (min !== undefined) {
                next = Math.max(min, next);
            }
            if (max !== undefined) {
                next = Math.min(max, next);
            }
            onChange?.(String(next));
        };

        return (
            <div className="afas-form-field afas-form-field--stacked afas-form-field--stepper">
                <Label htmlFor={inputId} className="afas-form-field__label">{field.label}</Label>
                <div className="afas-stepper">
                    <button
                        type="button"
                        className="afas-stepper__btn"
                        aria-label="Verlagen"
                        disabled={isReadOnly}
                        onClick={() => stepBy(-1)}
                    >
                        −
                    </button>
                    <Input
                        id={inputId}
                        className={`afas-stepper__input${compact ? ' clooser-control clooser-control--compact' : ''}`}
                        placeholder={field.placeholder}
                        value={value ?? ''}
                        disabled={isReadOnly}
                        onChange={(event) => onChange?.(event.target.value)}
                    />
                    <button
                        type="button"
                        className="afas-stepper__btn"
                        aria-label="Verhogen"
                        disabled={isReadOnly}
                        onClick={() => stepBy(1)}
                    >
                        +
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className={`afas-form-field afas-form-field--stacked${field.col === 'inline' ? ' afas-form-field--inline' : ''}`}>
            <Label htmlFor={inputId} className="afas-form-field__label">{field.label}</Label>
            <Input
                id={inputId}
                readOnly={isReadOnly}
                value={value ?? ''}
                onChange={onChange ? (event) => onChange(event.target.value) : undefined}
                className={controlClassName(compact)}
            />
        </div>
    );
};

export default AfasFormField;
